import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-arrow-resize-6",
  "use": "icon-si-glyph-arrow-resize-6-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-arrow-resize-6\" id=\"icon-si-glyph-arrow-resize-6\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1214</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M1.031,0 L6.008,0 C6.567,0 7.02,0.451 7.02,1.009 L5.44,2.584 L13.42,10.565 L14.99,9 C15.547,9 15.999,9.45 15.999,10.006 L15.999,14.952 C15.999,15.507 15.547,15.958 14.99,15.958 L10.028,15.958 C9.47,15.958 9.019,15.507 9.019,14.952 L10.601,13.375 L2.621,5.395 L1.031,6.98 C0.472,6.98 0.019,6.528 0.019,5.971 L0.019,1.009 C0.02,0.451 0.473,0 1.031,0 L1.031,0 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-arrow-resize-6.svg
// module id = UWqH
// module chunks = 62